import { useEffect, useRef, useState } from 'react';
import type { Banner } from '../types/models';
import { useNavigate } from 'react-router-dom';
import { mediaUrl } from '../lib/media';

export default function BannerCarousel({ banners }: { banners: Banner[] }) {
  const [active, setActive] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const w = el.clientWidth;
      const idx = Math.round(el.scrollLeft / w);
      setActive(idx);
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  if (!banners.length) return null;

  return (
    <div className="px-4 pt-3">
      <div
        ref={ref}
        className="flex gap-3 overflow-x-auto snap-x snap-mandatory no-scrollbar -mx-4 px-4 scroll-px-4"
      >
        {banners.map((b) => (
          <button
            key={b.id}
            onClick={() => {
              if (b.link_session_id) navigate(`/session/${b.link_session_id}`);
              else if (b.link_url) {
                const v = b.link_url.trim();
                const url = /^@[A-Za-z0-9_]+$/.test(v)
                  ? `https://t.me/${v.slice(1)}`
                  : /^https?:\/\//i.test(v) ? v : `https://${v}`;
                window.open(url, '_blank');
              }
            }}
            className="snap-start shrink-0 w-[88%] aspect-[16/8] rounded-xl2 overflow-hidden bg-bg-elev"
          >
            <img src={mediaUrl(b.image_url)} className="w-full h-full object-cover" alt="banner" />
          </button>
        ))}
      </div>
      {banners.length > 1 && (
        <div className="flex justify-center gap-1.5 mt-2">
          {banners.map((_, i) => (
            <span key={i} className={`h-1.5 rounded-full transition-all ${i === active ? 'w-5 bg-accent' : 'w-1.5 bg-line'}`} />
          ))}
        </div>
      )}
    </div>
  );
}
